import * as S from '@effect/schema/Schema';
import { nullable } from '@infl-ts/util-io-ts';
import * as t from 'io-ts';
var Member = t.type({
  id: t.string,
  name: t.string,
  isAdmin: t["boolean"],
  title: nullable(t.string),
  company: nullable(t.string),
  avatarUrl: nullable(t.string)
});
var SocialAccountBase = t.type({
  id: t.string,
  connected: t["boolean"],
  visible: t["boolean"]
});
var SocialAccountWithProfileUrl = t.type({
  __typename: t.keyof({
    Facebook: null,
    Linkedin: null,
    Twitter: null
  }),
  profileUrl: nullable(t.string)
});
var SocialAccount = t.intersection([t.union([SocialAccountWithProfileUrl, t.type({
  __typename: t.keyof({
    Apple: null,
    OAuth2: null,
    Google: null
  })
})]), SocialAccountBase], 'SocialAccount');
export var VisibleSocialAccount = t.intersection([t.union([SocialAccountWithProfileUrl, t.type({
  __typename: t.keyof({
    Apple: null,
    OAuth2: null
  })
})]), SocialAccountBase], 'VisibleSocialAccount');
var Profile = t.type({
  id: t.string,
  isAdmin: t["boolean"],
  isClone: t["boolean"],
  socialAccounts: t.array(SocialAccount)
});
export var MemberQuery = t.type({
  member: Member,
  profile: Profile
});
export var ProfileBlockConfig = S.struct({
  typename: S.literal('ProfileBlock'),
  id: S.string,
  hash: S.string,
  memberId: S.string
});